module.exports = __webpack_public_path__ + "img/7_86.3f7270c2.png";